var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.arbitrary)?_c('div',[(_vm.value)?_c('BadgeState',{attrs:{"color":_vm.stateBackground,"label":_vm.stateDisplay}}):_vm._e()],1):_c('BadgeState',{attrs:{"value":_vm.row}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }